const mockEvents = {
  city: {
    id: 1007700,
    city: "München",
    lat: 48.14,
    lon: 11.58,
    state: "",
    country: "de",
    zip: "meetup3",
    member_count: 1257
  },
  events: [
    {
      created: 1572344845000,
      duration: 7200000,
      id: "266042622",
      name: "Technology Radar Vol. 21 Presentation",
      rsvp_limit: 140,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1574877600000,
      local_date: "2019-11-27",
      local_time: "19:00",
      updated: 1573049111000,
      utc_offset: 3600000,
      waitlist_count: 37,
      yes_rsvp_count: 140,
      venue: {
        id: 25852478,
        name: "ThoughtWorks Munich ",
        lat: 48.135860443115234,
        lon: 11.613353729248047,
        repinned: true,
        address_1: "Bothestraße 11",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1413448074000,
        name: "ThoughtWorks Munich",
        id: 17658472,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "ThoughtWorks-Muenchen",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/ThoughtWorks-Muenchen/events/266042622/",
      description:
        '<p>*** Registrations via our website ***<br/><a href="https://www.thoughtworks.com/technology_radar_21_de" class="linkified">https://www.thoughtworks.com/technology_radar_21_de</a></p> <p>Adopt, trial, assess or hold?<br/>Get ahead of the latest technology trends.</p> <p>The Technology Radar, based on our observations, conversations and experiences with our customers, covers both existing and emerging technologies.</p> <p>The report divides the trends into four groups: Techniques, platforms, tools, programming languages and frameworks. Within these groups, each trend has a recommendation: "Hold" for technologies that are not initially recommended for use; "Assess" for technologies that require further evaluation; "Trial" for technologies that are ready for use; and "Adopt" for mature technologies.</p> <p>Learn more about the latest technology and join us for the event in our Munich office.</p> <p>We are looking forward to welcome you!</p> <p>Agenda:</p> <p>18:30 - 19:00 Registration and Drinks</p> <p>19:00 - 20:30 Technology Radar Presentation (incl. Q&amp;A)</p> <p>20:30 - 22:00 Get Together with drinks &amp; fingerfood</p> <p>The presentation will be held in English.</p> <p>---</p> <p>*** Registrierung über unsere Website ***<br/><a href="https://www.thoughtworks.com/de/technology_radar_21_de" class="linkified">https://www.thoughtworks.com/de/technology_radar_21_de</a></p> <p>Adopt, trial, assess oder hold?<br/>Erfahre von unseren Experten mehr zu den neuesten Technologietrends.</p> <p>Der Technology Radar, der auf unseren Beobachtungen, Gesprächen und Erfahrungen mit unseren Kunden beruht, behandelt sowohl existierende als auch neu aufkommende Technologien.</p> <p>Der Report teilt die Trends in vier Gruppen auf: Techniken, Plattformen, Tools sowie Programmiersprachen und Frameworks. Innerhalb dieser Gruppen wird jeder Trend mit einer Empfehlung versehen: „Hold“ für Technologien, von deren Verwendung vorerst abgeraten wird; „Assess“ für Technologien, die einer weiteren Evaluation bedürfen; „Trial“ für Technologien, die einsatzbereit sind und „Adopt“ für ausgereifte Technologien.</p> <p>Erfahre mehr über die neusten Technologietrends und melde dich für unsere Technology Radar Präsentation in München an.</p> <p>Wir freuen uns auf dich!</p> <p>Agenda:</p> <p>18:30 - 19:00 Registrierung und Drinks</p> <p>19:00 - 20:30 Technology Radar Präsentation (inkl. Q&amp;A)</p> <p>20:30 - 22:00 Get Together mit Drinks &amp; Fingerfood</p> <p>Die Präsentation findet auf Englisch statt.</p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1573991200000,
      duration: 9000000,
      id: "266531235",
      name:
        "A Virtual Helpdesk Assistant with LUIS.ai, Cognitive Services and Bot Framework",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1574958600000,
      local_date: "2019-11-28",
      local_time: "17:30",
      updated: 1574007011000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 18,
      group: {
        created: 1562061882000,
        name: "Azure DEV Meetup Munich",
        id: 32304402,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Azure-DEV-Munich",
        who: "Azure native",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Azure-DEV-Munich/events/266531235/",
      description:
        '<p>+++ This is a shared Meetup with München .Net Meetup +++<br/>+++ Origin Event: <a href="https://www.meetup.com/de-DE/Munchen-NET-Meetup/events/266381022/" class="linkified">https://www.meetup.com/de-DE/Munchen-NET-Meetup/events/266381022/</a> +++</p> <p>Microsoft AI MVP Georgia Kalyva, will talk about how to use the Azure Bot Service together with Azure Cognitive Services, to create a virtual help-desk assistant in 3 simple steps: First, create a knowledge base, then create a natural language model using LUIS.ai (Language Understanding Intelligent Service) and finally combine everything to create and deploy the bot to the Azure App Service, to be publicly available everywhere. Publish options include Skype, Teams and more.</p> <p>AGENDA<br/>---------------------------------------------------------------<br/>• 17:30 Doors Open<br/>• 18:00 Welcome note - Connect with Georgia<br/>• 18:05 Introduction to Azure Bot Service<br/>• 18:20 How to create a knowledge base using the QnA Maker<br/>• 18:35 Introduction to LUIS.ai<br/>• 19:00 Create and testing our bot<br/>• 19:10 Other publish options<br/>• 19:20 Q&amp;Α<br/>• 20:00 End of Event - Glühwein oder Bier?</p> <p>DISCLAIMER<br/>---------------------------------------------------------------<br/>We will connect with Georgia from Skype and the event will be presented remotely. Since Georgia will not actually be present, cameras will be on!</p> ',
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1573465178000,
      duration: 7200000,
      id: "266379229",
      name: "Deep Fakes 2.0 - How Neural Networks are Changing our World",
      rsvp_limit: 50,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575394200000,
      local_date: "2019-12-03",
      local_time: "18:30",
      updated: 1573584962000,
      utc_offset: 3600000,
      waitlist_count: 2,
      yes_rsvp_count: 50,
      group: {
        created: 1565272185000,
        name: "OpenValue München",
        id: 32563109,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "OpenValueMuenchen",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/OpenValueMuenchen/events/266379229/",
      description:
        "<p>Imagine looking into a mirror and not seeing your own face. Instead, you are looking in the eyes of Barack Obama or Angela Merkel. Your facial expressions are seamlessly transferred to that other person's face in real time.</p> <p>The TNG Hardware Hacking Team has managed to create a prototype that transfers faces from one person to another in real time, based on Deep Fakes. Neural networks detect faces within a video input, then translate them and integrate them back to the video output. Through this technique, it is possible to project deceptively real imitations onto other people. For this purpose, we used Keras trained autoencoder networks and various face recognition algorithms. In the talk, Thomas Endres and Martin Förtsch will give an entertaining and vivid introduction into the world of real-time Deep Fakes. In doing so, they particularly focus on the deep learning techniques used in within the application. Several live demonstrations will complete this event.</p> <p>Keywords: Tensorflow, OpenCV, Keras, UNet, MobileNet, Transfer Learning, Deep Learning, Autoencoder, Realtime Deepfake</p> ",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1573817037000,
      duration: 3600000,
      id: "266488053",
      name:
        "Geomob Munich Team Meeting: Join us and help plan the events for 2020",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575387900000,
      local_date: "2019-12-03",
      local_time: "16:45",
      updated: 1573817051000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 7,
      group: {
        created: 1551172295000,
        name: "Geomob Munich #geomobMUC",
        id: 31257448,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Geomob-Munich-geomobMUC",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Geomob-Munich-geomobMUC/events/266488053/",
      description:
        '<p>Join the Geomob Munich Team!</p> <p>Did you enjoy the Geomob Munich meetups so far? Whether it was for fun or business, we certainly hope you had a good time at the 3 events so far.</p> <p>Geomob Munich is similar to an open source project. We want to expand the team and get more people involved in organizing the events for the coming year.</p> <p>We are constantly looking at ways to improve the event and make it more fun and useful. This is your chance to sit down with us and help build a strong spatial community here in Munich.</p> <p>The plan is to meet at 16.45 close to Wayra where the meetup on "Mobility and Location Intelligence" is scheduled the same evening as our team meeting. Lets get a coffee and have a chat about Geomob Munich 2020. After that we head to Wayra for the 4th Geomob Munich meetup :)</p> <p>If you have any questions, please feel free to reach out to us via meetup or via email at [masked]</p> <p>Your Geomob Munich Team,<br/>Muthu, Abhi, Florian (and hopefully you!)</p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571223250000,
      duration: 7200000,
      id: "265709123",
      name: "Best Startups from Hamburg - Pitchnight#1 - München",
      rsvp_limit: 200,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1579111200000,
      local_date: "2020-01-15",
      local_time: "19:00",
      updated: 1571770971000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 50,
      group: {
        created: 1571221326000,
        name: "Wow Yes Startups - München",
        id: 32898396,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "wow-yes-Startups-Munchen",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/wow-yes-Startups-Munchen/events/265709123/",
      description:
        '<p>HAMBURG’S BEST STARTUPS VISIT MUNICH</p> <p>we connect startups with matching investors.</p> <p>Wir laden alle Startups, Investoren und sonstige Interessierte herzlich ein, an diesem Abend dabei zu sein!</p> <p>Die fünf Gewinner unserer Hamburger Startup Competition pitchen ihr Business vor interessierten Investoren und Publikum in München. Wir freuen uns auf einen tollen Abend in entspannter Atmosphäre!</p> <p>Ablauf:</p> <p>Beginn um 19:00 Uhr<br/>Pitch eines erfolgreichen, lokalen Startups<br/>5 Pitches der besten Hamburger Startups<br/>Q&amp;A mit Münchner Investoren und Startup Community<br/>Lokale Jury wählt das Gewinnerstartup des Abends<br/>Networking an der Bar<br/>Ende um 22:00 Uhr</p> <p>Alle Infos zu uns und unseren Events findest Du hier: <a href="https://www.meetup.com/de-DE/wow-yes-Startups-Munchen/" class="linkified">https://www.meetup.com/de-DE/wow-yes-Startups-Munchen/</a></p> <p>******************************************</p> <p>ENGLISH</p> <p>You are a startup, investor or just curious about the startup community? Then you are cordially invited to meet Hamburg’s best startups in Munich!</p> <p>The five winners of our Hamburg Startup Competition will pitch their business in front of interested investors and the public in Munich. We are looking forward to a great evening in a relaxed atmosphere!</p> <p>Agenda:</p> <p>Start at 7 p.m.<br/>Pitch of a successful, local startup<br/>5 pitches from Hamburg’s best startups<br/>Q&amp;A with Munich investors and startup community<br/>Local jury selects the winner startup of the evening<br/>Networking at the bar<br/>End at 10 p.m.</p> <p>You can find all information about us and our events here: <a href="https://www.meetup.com/de-DE/wow-yes-Startups-Munchen/" class="linkified">https://www.meetup.com/de-DE/wow-yes-Startups-Munchen/</a></p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1567171503000,
      duration: 10800000,
      id: "264426961",
      name: 'Let\'s read Chapter 3 of "Seven Sketches in Compositionality"',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576171800000,
      local_date: "2019-12-12",
      local_time: "18:30",
      updated: 1573826760000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 15,
      group: {
        created: 1567165400000,
        name: "Applied Category Theory Munich",
        id: 32696620,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Applied-Category-Theory-Munich",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Applied-Category-Theory-Munich/events/264426961/",
      description:
        '<p>3rd Meetup of the Applied Category Theory Munich group.<br/>Chapter 3: "Databases: Categories, Functors, and Universal Constructions"</p> <p>-----------------------------------------------------<br/>TL;DR<br/>- start &lt;[masked] Thu 18:30&gt; @ Tropeninstitut LMU, Leopoldstr. 7, 3rd floor, Room 305<br/>- review Chapter 3<br/>-----------------------------------------------------</p> <p>Let\'s continue and read Chapter 3 of "Seven Sketches in Compositionality"<br/>until &lt;[masked] Thu&gt;, and we meet again 6:30 pm at the "Department of Infectious Diseases &amp; Tropical Medicine".</p> <p>There will be no food, so please eat before or bring your own dinner.</p> <p>In the same format as last time, we go through the main definitions, theorems, examples and exercises in the chapter. Please feel invited to also come up with interesting questions, applications, maybe examples from your own work.</p> <p>Video lectures covering the Chapter 3 can be found here:<br/><a href="https://ocw.mit.edu/courses/mathematics/18-s097-applied-category-theory-january-iap-2019/lecture-videos-and-readings/chapter-3-databases-categories-functors-and-co-limits/" class="linkified">https://ocw.mit.edu/courses/mathematics/18-s097-applied-category-theory-january-iap-2019/lecture-videos-and-readings/chapter-3-databases-categories-functors-and-co-limits/</a></p> <p>We also started a git repository to share interesting links:<br/><a href="https://github.com/drever/act-munich" class="linkified">https://github.com/drever/act-munich</a></p> <p>If you have wishes, ideas, suggestions to enrich the meetup, please reach out to us.</p> <p>If you cannot make it, please update your RSVP status as early as possible to allow members on the waiting list to participate.</p> ',
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1571126564000,
      duration: 10800000,
      id: "265679947",
      name: "Monero Munich Stammtisch",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576778400000,
      local_date: "2019-12-19",
      local_time: "19:00",
      updated: 1572199782000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      group: {
        created: 1510658046000,
        name: "Monero Munich",
        id: 26595449,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Monero-Munich",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Monero-Munich/events/265679947/",
      description:
        "<p>Hello Monero enthusiasts,</p> <p>this is our regular monthly meetup, where we get together and discuss the latest news.</p> <p>Please RVSP if you're planning to come and shoot me a message if you have any questions.</p> <p>Looking forward to it!</p> ",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571982461000,
      duration: 7200000,
      id: "bksmkryzpbnc",
      name: "Weekend Coffee for Startup People",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575126000000,
      local_date: "2019-11-30",
      local_time: "16:00",
      updated: 1571982461000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 6,
      venue: {
        id: 26033912,
        name: "Park Café",
        lat: 48.1423454284668,
        lon: 11.56462287902832,
        repinned: true,
        address_1: "Sophienstraße 7",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1443569671000,
        name: "Munich Startup Ecosystem by StartupBlink",
        id: 18980890,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "StartupBlink-Munchen",
        who: "Startup Heroes",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/StartupBlink-Munchen/events/bksmkryzpbnc/",
      description:
        '<p>This event brings together a small group of local entrepreneurs over a cup of coffee in a relaxing and informal atmosphere.</p> <p>Here you will have an opportunity to introduce your business and ideas and not only listen but TALK as well. It is your chance to meet with other participants from diverse industries and find the resources you need, be that business connections, new co-founder, encouragement to start a freelancing career or even ideas on selling.</p> <p>Unlike other Startup events, Weekend Coffee success is solely based on participants attendance and willingness to lead the event, therefore, by RSVPing, you are not only ensuring your seat, but become the event itself. So, make sure to arrive as other attendees are counting on you!</p> <p>Besides that, some of the events are organized by our City Partners <a href="https://citypartner.startupblink.com" class="linkified">https://citypartner.startupblink.com</a> or by local volunteers. If you are willing to lead this event every weekend, we will grant you admin rights so you can set the time and day of your choice. Send us a quick email at [masked]</p> <p>Huamei will be your Event Leader this time.</p> <p>Remember to check the comments below for updates and to find the group on the day of the event. If you arrive first at the cafe, just pick a table and post in the comments section below where you are sitting and how to identify you (e.g. shirt color).</p> <p>Enjoy your coffee with new friends!<br/>_ _ _</p> <p>Do you Telegram?<br/>Join the conversation in our global startup chat and connect with entrepreneurs from all over the world. <a href="https://t.me/workjams" class="linkified">https://t.me/workjams</a></p> <p>_ _ _</p> <p>Looking for more networking opportunities?<br/>Join a coworking space to increase your work efficiency and meet your new clients, team members, and investors. Our partners at WeWork have an exclusive offer for you in over 600 locations around the world.<br/>Schedule a free tour and apply through this link to get up to 15% discount.<br/><a href="https://wework.startupblink.com" class="linkified">https://wework.startupblink.com</a></p> ',
      how_to_find_us:
        "Know a better location for this meetup? Just send us a message, and we'll change it for you!",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1571982461000,
      duration: 7200000,
      id: "bksmkryzqbkb",
      name: "Weekend Coffee for Startup People",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575730800000,
      local_date: "2019-12-07",
      local_time: "16:00",
      updated: 1571982461000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 26033912,
        name: "Park Café",
        lat: 48.1423454284668,
        lon: 11.56462287902832,
        repinned: true,
        address_1: "Sophienstraße 7",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1443569671000,
        name: "Munich Startup Ecosystem by StartupBlink",
        id: 18980890,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "StartupBlink-Munchen",
        who: "Startup Heroes",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/StartupBlink-Munchen/events/bksmkryzqbkb/",
      description:
        '<p>This event brings together a small group of local entrepreneurs over a cup of coffee in a relaxing and informal atmosphere.</p> <p>Here you will have an opportunity to introduce your business and ideas and not only listen but TALK as well. It is your chance to meet with other participants from diverse industries and find the resources you need, be that business connections, new co-founder, encouragement to start a freelancing career or even ideas on selling.</p> <p>Unlike other Startup events, Weekend Coffee success is solely based on participants attendance and willingness to lead the event, therefore, by RSVPing, you are not only ensuring your seat, but become the event itself. So, make sure to arrive as other attendees are counting on you!</p> <p>Besides that, some of the events are organized by our City Partners <a href="https://citypartner.startupblink.com" class="linkified">https://citypartner.startupblink.com</a> or by local volunteers. If you are willing to lead this event every weekend, we will grant you admin rights so you can set the time and day of your choice. Send us a quick email at [masked]</p> <p>Huamei will be your Event Leader this time.</p> <p>Remember to check the comments below for updates and to find the group on the day of the event. If you arrive first at the cafe, just pick a table and post in the comments section below where you are sitting and how to identify you (e.g. shirt color).</p> <p>Enjoy your coffee with new friends!<br/>_ _ _</p> <p>Do you Telegram?<br/>Join the conversation in our global startup chat and connect with entrepreneurs from all over the world. <a href="https://t.me/workjams" class="linkified">https://t.me/workjams</a></p> <p>_ _ _</p> <p>Looking for more networking opportunities?<br/>Join a coworking space to increase your work efficiency and meet your new clients, team members, and investors. Our partners at WeWork have an exclusive offer for you in over 600 locations around the world.<br/>Schedule a free tour and apply through this link to get up to 15% discount.<br/><a href="https://wework.startupblink.com" class="linkified">https://wework.startupblink.com</a></p> ',
      how_to_find_us:
        "Know a better location for this meetup? Just send us a message, and we'll change it for you!",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1572423470000,
      duration: 10800000,
      id: "266070731",
      name: "Event-Driven REST APIs ",
      rsvp_limit: 220,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1574875800000,
      local_date: "2019-11-27",
      local_time: "18:30",
      updated: 1572534786000,
      utc_offset: 3600000,
      waitlist_count: 122,
      yes_rsvp_count: 220,
      venue: {
        id: 25683907,
        name: "MAN Truck & Bus Deutschland GmbH",
        lat: 48.180694580078125,
        lon: 11.596031188964844,
        repinned: true,
        address_1: "Oskar-Schlemmer-Straße 19-21",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1399578043000,
        name: "Microservices Meetup Munich",
        id: 14341692,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Microservices-Meetup-Munich",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Microservices-Meetup-Munich/events/266070731/",
      description:
        '<p>Vaughn Vernon: Event-Driven REST APIs</p> <p>Please keep your RSVP up to date, free spots are always in demand!</p> <p>We will meet at 6:30pm at the canteen of RIO – a Brand of Volkswagen Truck &amp; Bus (MAN Truck &amp; Bus building), with drinks and pizza.</p> <p>The talk starts at 7pm and will be in English.<br/>After the talk we have time for drinks and conversations.</p> <p>Abstract<br/>When should you use request-response and when should you use messaging instead? What if you could use REST for everything, including Event-Driven Architectures?</p> <p>Learn how to design REST APIs that support both conventional human user interfaces and services, and those that support Event-Driven, and more generally, Message-Driven Architectures. As a bonus, expect to pick up tips on Reactive programming. This session is about REST API design for request-response and event-driven microservices with Domain Events using Event Sourcing and CQRS.</p> <p>Bio:<br/>Vaughn, Founder and Chief Architect of Kalele, is the visionary behind the vlingo/PLATFORM. A software developer with more than 35 years of experience in a broad range of business domains, Vaughn is a leading expert in Domain-Driven Design (DDD), and a champion of simplicity and reactive systems. As a consultant and teacher of DDD and Reactive software development, he has helped thousands of developers and numerous teams and organizations. He leads clients to realize innovative, business-driven, reactive, digital systems, as they transform from a legacy of brittle, technology-driven, stagnation. Vaughn is the author of three books: Implementing Domain-Driven Design, Domain-Driven Design Distilled, and Reactive Messaging Patterns with the Actor Model, all published by Addison-Wesley.</p> <p>Location:<br/>Canteen, entrance via<br/>Walter-Gropius-Straße 19<br/><a href="https://goo.gl/maps/y7rRtWyikmm" class="linkified">https://goo.gl/maps/y7rRtWyikmm</a></p> ',
      how_to_find_us: "Canteen, Walter-Gropius-Str. 19",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1572885755000,
      duration: 7200000,
      id: "266207271",
      name: "17. Treffen der Gruppe Software Architektur München",
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575999000000,
      local_date: "2019-12-10",
      local_time: "18:30",
      updated: 1572886100000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 43,
      venue: {
        id: 25881465,
        name: "TNG Technology Consulting GmbH",
        lat: 48.15310287475586,
        lon: 11.616222381591797,
        repinned: true,
        address_1: "Arabellastraße 4a",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1473607978000,
        name: "Software Architektur München",
        id: 20413739,
        join_mode: "approval",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Software-Architektur-Muenchen",
        who: "Software-Gestalter",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Software-Architektur-Muenchen/events/266207271/",
      description:
        '<p>Liebe Mitglieder der Meetup-Gruppe Software Architektur München,</p> <p>unser nächstes Treffen steht an und wir haben zwei spannende Vorträge:</p> <p>Vortrag: "Rettet den Mud-olith!<br/>Sprecher: Daniel Götz und Peter Gafert</p> <p>Vortrag: Qualitäts-Türchen statt Quality-Gates<br/>Sprecher: Florian Deißenböck</p> <p>Abstracts finden sich wie immer auf unsere Seite <a href="https://swa-muc.de/" class="linkified">https://swa-muc.de/</a></p> <p>Wir werden uns am 10. Dezember 2019 um 18:30 Uhr in den Räumen von TNG Technology Consulting GmbH in der Arabellastraße treffen:</p> <p>Arabellastraße 4a<br/>81925 München</p> <p>ca. 3 Minuten von der U-Bahn-Haltestelle der U4 / Arabellapark weg, mit dem Auto kann man hier parken: <a href="https://en.parkopedia.com/parking/locations/arabellastraße_4a_81925_münchen_deutschland_u283bq4bkek/?arriving=[masked]&amp;leaving=[masked]" class="linkified">https://en.parkopedia.com/parking/locations/arabellastraße_4a_81925_münchen_deutschland_u283bq4bkek/?arriving=[masked]&amp;leaving=[masked]</a></p> <p>Für Getränke und Essen ist gesorgt.</p> ',
      how_to_find_us:
        "https://www.tngtech.com/tng-ueber-uns/anfahrt.html#c20978",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1573215558000,
      duration: 7200000,
      id: "266314095",
      name:
        "Läuft bei dir - Routineaufgaben mit RPA und KI ganz einfach automatisieren!",
      rsvp_limit: 40,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1574784000000,
      local_date: "2019-11-26",
      local_time: "17:00",
      updated: 1573215558000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 18,
      venue: {
        id: 25799146,
        name: "Criterion",
        lat: 48.104759216308594,
        lon: 11.600908279418945,
        repinned: true,
        address_1: "Aschauer Str. 30",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1518441164000,
        name: "Materna Digital Hub in München",
        id: 27486139,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Materna-Digital-Hub-Muenchen",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Materna-Digital-Hub-Muenchen/events/266314095/",
      description:
        '<p>Wir laden Sie herzlich ein zu unserem After-Work-Event „Materna Digital hub“ in München am 26. November 2019 ab 17.00 Uhr!</p> <p>RPA wird von immer mehr Organisationen verwendet, um die Produktivität an PC-Arbeitsplätzen durch Automatisierung weiter zu verbessen.</p> <p>Seine wahren Vorteile spielt RPA erst aus, wenn Sie kognitive Intelligenz, maschinelles Lernen und robotergesteuerte Prozessautomatisierung kombinieren. Damit befreien Sie Mitarbeiter von wiederkehrenden Aufgaben, steigern die Effizienz an den Arbeitsplätzen und senken gleichzeitig die Fehlerrate bei manuellen Dateneingaben.</p> <p>Damit Sie sich ein konkretes Bild von der Leistungsfähigkeit einer solchen Lösung machen können, zeigen wir Ihnen eine Live-Demo auf Basis der Software Automation Anywhere.</p> <p>Das erwartet Sie am 26. September von 17:00 bis 20:00 Uhr<br/> Robotic Process Automation vs. Makro-Rekorder: Was ist RPA und warum ist das jetzt (wieder) ein Hype-Thema? (Materna)<br/> Robotic Process Automation oder API: Für jeden Anwendungsfall die richtige Automatisierung (Materna)<br/> Anwendungsfälle für Robotic Process Automation sowie Demo (Materna)<br/> Next-level Robotic Process Automation: Wie bringt Automation Anywhere "cognitive" in die Automatisierung? Vorstellung kognitiver RPA-Anwendungsfälle und IQBot Demo (Automation Anywhere)</p> <p>Im Anschluss freuen wir uns auf den Austausch bei Canapés und Co.</p> <p>Die Teilnahme ist kostenlos für Sie.</p> ',
      how_to_find_us:
        "Der Weg zu den Räumlichkeiten wird im Gebäude ausgeschildert",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571041533000,
      duration: 14400000,
      id: "265653490",
      name: "AfterWERK meets MUNICH STARTUP.de / Official Opening Ceremony",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1574960400000,
      local_date: "2019-11-28",
      local_time: "18:00",
      updated: 1572965773000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 88,
      venue: {
        id: 26681723,
        name: "Atelierstraße 29",
        lat: 48.12380599975586,
        lon: 11.608274459838867,
        repinned: true,
        address_1: "Atelierstraße 29",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1458124246000,
        name: "WERK1",
        id: 19716609,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "WERK1munich",
        who: "movers and shakers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/WERK1munich/events/265653490/",
      description:
        "<p>Once per month, the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself, write to [masked].</p> <p>This time, our AfterWERK will also be an official opening ceremony of the former C2 Photo Studio, which we have now officially taken over as WERK1. There will be a cocktail bar, buffet, and live music from the LOVEMEN band!</p> <p>In a nutshell<br/>– Thursday, 28th November 2019 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 4 minutes each</p> ",
      how_to_find_us:
        'Access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574173723000,
      duration: 7200000,
      id: "266581198",
      name: "AfterWERK meets MUNICH STARTUP.de",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1579194000000,
      local_date: "2020-01-16",
      local_time: "18:00",
      updated: 1574173723000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 27,
      venue: {
        id: 26681723,
        name: "Atelierstraße 29",
        lat: 48.12380599975586,
        lon: 11.608274459838867,
        repinned: true,
        address_1: "Atelierstraße 29",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1458124246000,
        name: "WERK1",
        id: 19716609,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "WERK1munich",
        who: "movers and shakers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/WERK1munich/events/266581198/",
      description:
        "<p>Once per month, the Munich Startup Community meets at WERK1 for the famous „Feierabend-Bier“, snacks and wine!</p> <p>Join us for 1-2 pitches &amp; networking. If you are interested in pitching yourself, write to [masked].</p> <p>In a nutshell<br/>– Thursday, 16th January 2020 || 6pm<br/>– Informal networking with snacks &amp; drinks<br/>– Meet Munich Entrepreneurs Startups &amp; Freelancers<br/>– max. 2 startup pitches, 4 minutes each</p> ",
      how_to_find_us:
        'Access by car only via "Piusstraße", coming by S-Bahn Ostbahnhof enter Werksviertel on "Speicherstraße".',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574156592000,
      duration: 7200000,
      id: "266577925",
      name:
        'WERKSAcademy by mynd:way | "How to empower your workforce for mynd:ful growth"',
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1582041600000,
      local_date: "2020-02-18",
      local_time: "17:00",
      updated: 1574156602000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 6,
      venue: {
        id: 26052503,
        name: "WERK1 München",
        lat: 48.123779296875,
        lon: 11.608222961425781,
        repinned: false,
        address_1: "Atelierstraße 29",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1458124246000,
        name: "WERK1",
        id: 19716609,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "WERK1munich",
        who: "movers and shakers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/WERK1munich/events/266577925/",
      description:
        '<p>TICKETS ARE ONLY SOLD THROUGH EVENTBRITE<br/><a href="https://www.eventbrite.de/e/werksacademy-powered-by-myndway-how-to-empower-your-workforce-for-myndful-growth-tickets-82785968059" class="linkified">https://www.eventbrite.de/e/werksacademy-powered-by-myndway-how-to-empower-your-workforce-for-myndful-growth-tickets-82785968059</a></p> <p>WERKSAcademy powered by mynd:way | "One step ahead: How to empower your workforce for mynd:ful growth"</p> <p>As an entrepreneur, you want your employees to shine. You want them to know their strengths and weaknesses, and you want to be able to grow together as an outstanding team. In this 1.5 hour workshop, we will address how to empower your workforce through dedicated tool-sets. Feel free to bring along some of your current challenges regarding workforce empowerment and use the setting as a sounding board.</p> <p>Together, we will also look at tools for designing individual roles and apply methods of communication to fully understand everyone\'s potential as well as visions for their career. We will see what mindfulness practices have to do with new leadership and how it can become an enabler to an agile workforce.</p> <p>Come and join. We are happy to learn from you and grow together with you.</p> <p>When: Tuesday, February 18th @5 - 7PM -- presentation, followed by discussion, networking &amp; drinks</p> <p>Where: WERK1, Atelierstr. 29 (room: „Workshopraum”)</p> <p>Who: Startups &amp; Coworker from the Munich ecosystem</p> <p>Speaker: Tim Kuntze &amp; Dr. Martina Dopfer | mynd:way</p> <p>The event will be in English.</p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574071212000,
      duration: 18000000,
      id: "266552544",
      name: "jobs and master München 2020",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1578574800000,
      local_date: "2020-01-09",
      local_time: "14:00",
      updated: 1574354888000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      venue: {
        id: 26052459,
        name: "Zenith",
        lat: 48.19461441040039,
        lon: 11.608100891113281,
        repinned: true,
        address_1: "Lilienthalallee 29",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1501244830000,
        name: "Tech_Hub München",
        id: 25186228,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Tech_Hub-Munchen",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Tech_Hub-Munchen/events/266552544/",
      description:
        '<p>Karriere-Event jobs and master</p> <p>Finde den Job, der zu deinen Stärken passt. Das Karriere-Event jobs and master stellt dir mehr als 1.000 attraktive Jobangebote und Masterprogramme vor. Ein Matching System führt dich direkt zu den richtigen Unternehmen und Hochschulen. Spannende Games geben dir die Möglichkeit, deine Fähigkeiten deinem künftigen Arbeitgeber zu präsentieren. Geboten sind außerdem interessante Infos zu Trends und Entwicklungen im Arbeitsmarkt 4.0, den digitalen Berufen und die Chance, in kleinem Kreis zu diskutieren, Leute kennenzulernen und sich neu zu vernetzen.</p> <p>WER? Studierende, Absolventen und Young Professionals der Fachrichtungen MINT, Wirtschafts- und Geisteswissenschaften</p> <p>WANN? Donnerstag, 9. Januar 2020, 14-19 Uhr</p> <p>WO? Kulturhalle Zenith, Lilienthalallee 29, 80939 München</p> <p>WAS? Jobmesse, Masterstudiengänge, interaktiver Career Parcours, Workshops, Coachings, Fachvorträge und Get-Together</p> <p>Infos und Gratis-Ticket sichern unter <a href="https://www.jobsandmaster.de/" class="linkified">https://www.jobsandmaster.de/</a></p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571590130000,
      duration: 7200000,
      id: "265818385",
      name: " Akka Streams to the Extreme",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575482400000,
      local_date: "2019-12-04",
      local_time: "19:00",
      updated: 1571608602000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 62,
      venue: {
        id: 26090924,
        name: "JetBrains Event Space",
        lat: 48.13762664794922,
        lon: 11.5233154296875,
        repinned: true,
        address_1: "Elsenheimerstraße 47A",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1344375043000,
        name: "Munich Scala User Group",
        id: 4493412,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "ScalaMuc",
        who: "Scalaphiles",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/ScalaMuc/events/265818385/",
      description:
        '<p>For our December meetup, Heiko Seeberger will be talking about "Akka Streams to the Extreme"</p> <p>Actors are a powerful yet highly focussed and rather low-level tool. Often there are better ways to implement certain aspects of a domain. In this talk we share our experiences with using Akka Streams at the core of the web services created at MOIA which offers ride sharing services. We will argue that streams can be a great fit to implement the typical processes of web applications and we will investigate how Akka Streams can be used to protect against overload, enable lossless redeployments and – by using some advanced features – even enable something like "stream sharding".</p> <p>-----</p> <p>And of course, there will be ample opportunity to discuss Scala with other enthusiasts before and after Heiko\'s talk over Pizza and drinks at the JetBrains Event Space!</p> ',
      how_to_find_us:
        "Follow the signs and find the right-hand entrance in the back of the courtyard. Then take the elevator (not the stairs) to 5th floor.",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574271593000,
      duration: 14400000,
      id: "266612239",
      name: "Workshop: Introduction to Theorem Proving with Isabelle/HOL",
      rsvp_limit: 45,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1579021200000,
      local_date: "2020-01-14",
      local_time: "18:00",
      updated: 1574286486000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 29,
      venue: {
        id: 26112492,
        name: "Google",
        lat: 48.143035888671875,
        lon: 11.541084289550781,
        repinned: true,
        address_1: "Erika-Mann-Straße 33",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1372413211000,
        name: "Munich Lambda",
        id: 9128172,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Munich-Lambda",
        who: "Hackers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Munich-Lambda/events/266612239/",
      description:
        '<p>!!! THIS IS EXACTLY THE SAME WORKSHOP AS ON NOVEMBER 4, 2019 !!!</p> <p>Due to the big success of our last workshop we\'re bringing back the Introduction to Isabelle workshop for one more iteration, so people who couldn\'t make it last time have a chance to attend. If you\'ve already taken part in the workshop in November 2019, please don\'t come to this one! There\'s an advanced course in the works right now for those who want to learn more after going through one of the introduction workshops. Further news soon to follow.</p> <p>But now for the description of this event:</p> <p>Did you ever want to write *correct* code? Welcome to the world of proving your code correct with Isabelle/HOL. Bring your laptop! We start out with some basic functional programming, implementing a list. Then, we will show properties about our code. In particular, we will show that reversing a list twice gives back the original list.</p> <p>Are you willing to spend some hours reversing a list twice? Be warned that Isabelle/HOL has a very steep learning curve. Also, be warned that -- once you feel comfortable -- theorem proving is highly addictive.</p> <p>You will NEED to bring a laptop with at least 8G of RAM and Isabelle installed. You can get Isabelle here: <a href="https://isabelle.in.tum.de/" class="linkified">https://isabelle.in.tum.de/</a></p> <p>Language: English and German</p> <p>Speaker: Cornelius Diekmann</p> <p>Duration: about 4h (!!)</p> <p>This workshop is limited to 40 people. If you can\'t make it, please be sure to update your RSVP as soon as possible, especially if there\'s a waitlist.</p> <p>!!! This is a Google hosted event. We need real names for attendees so we can ensure entry to Google premises. Please fill out this form even if you were waitlisted: <a href="https://forms.gle/A6Fcsw3XyFpznHJE6" class="linkified">https://forms.gle/A6Fcsw3XyFpznHJE6</a> !!!</p> <p>There will be snacks :-)</p> <p>You will NEED to bring a laptop with at least 8G of RAM and Isabelle installed. You can get Isabelle here: <a href="https://isabelle.in.tum.de/" class="linkified">https://isabelle.in.tum.de/</a></p> <p>Photo by Simon Lackerbauer.</p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571642958000,
      duration: 10800000,
      id: "265832961",
      name: "Beer, Brotzeit and IoT @ Concept Reply",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576778400000,
      local_date: "2019-12-19",
      local_time: "19:00",
      updated: 1574185952000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 80,
      venue: {
        id: 26066109,
        name: "Luise-Ullrich-Straße 14",
        lat: 48.14474868774414,
        lon: 11.538175582885742,
        repinned: true,
        address_1: "Luise-Ullrich-Straße 14",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1508251656000,
        name: "München IoT Meetup",
        id: 26294946,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Muenchen-IoT-Meetup",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Muenchen-IoT-Meetup/events/265832961/",
      description:
        '<p>WE HAVE A BRAND NEW VENUE! Please come on over and take a look :)</p> <p>Agenda:</p> <p>19:00: Just enough time to grab a beer and snack<br/>19:20: Alyosh "Alex" Agarwal (Senior Consultant for Big Data Analytics, AI, ML currently working at Mercedes-Benz/Daimler) - IoT within Recommendation Engines in the Automobile Industry<br/>19:40: Andreas Kammerloher (Engineering Consultant at Pixida GmbH) - Nerves: Craft and deploy bulletproof embedded IoT software in Elixir<br/>20:00: Alexander Lehmann (Technical Manager at Sigfox) - What do Rhinos have in common with Containers?<br/>20:20: Networking/Banter</p> <p>Food and drink served throughout. All presentations in English.</p> ',
      how_to_find_us:
        "Public transportation:\nDonnersbergerstraße | 250m\n(Tram 16, 17)\nDonnersbergerbrücke | 450m\n(Suburban train towards Pasing, Bus 53 & 63)\n\nAddress:\nConcept Reply (part of the REPLY AG group)\nLuise-Ullrich-Straße 14\n80636 München",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574509161000,
      duration: 7200000,
      id: "266684231",
      name: "Christkindlmarkt Get-Together",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575655200000,
      local_date: "2019-12-06",
      local_time: "19:00",
      updated: 1574524936000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      venue: {
        id: 26745998,
        name: "Isar Gate",
        lat: 48.135108947753906,
        lon: 11.582098960876465,
        repinned: true,
        address_1: "Tal 50",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1372413211000,
        name: "Munich Lambda",
        id: 9128172,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Munich-Lambda",
        who: "Hackers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Munich-Lambda/events/266684231/",
      description:
        '<p>This will just be a little pre-Christmas get-together for all members at the Münchner Feuerzangenbowle (see <a href="https://www.muenchen.de/veranstaltungen/event/6943.html" class="linkified">https://www.muenchen.de/veranstaltungen/event/6943.html</a>, link German only). We\'ll meet up, have some punch or Glühwein and talk, whether about functional programming related stuff or anything else.</p> <p>There will be no agenda or structured talks.</p> <p>The event will take place regardless of weather conditions.</p> ',
      how_to_find_us: "Meeting point description follows",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571293653000,
      duration: 10800000,
      id: "265735738",
      name: "AI for Business Meetup #1 in München",
      rsvp_limit: 90,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1579798800000,
      local_date: "2020-01-23",
      local_time: "18:00",
      updated: 1573064810000,
      utc_offset: 3600000,
      waitlist_count: 17,
      yes_rsvp_count: 90,
      venue: {
        id: 26285058,
        name: "LinkedIn Munich",
        lat: 48.13643264770508,
        lon: 11.571603775024414,
        repinned: true,
        address_1: "Sendlinger Str. 12",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1571225713000,
        name: "AI for Business in München - Use cases and Networking",
        id: 32898601,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "AI-for-Business-in-Munchen-Use-cases-and-Networking",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/AI-for-Business-in-Munchen-Use-cases-and-Networking/events/265735738/",
      description:
        '<p>Unser erstes AI for Business Meetup findet am 23. Januar 2020 in München statt.</p> <p>Wir haben bereits viele erfolgreiche Meetups in Zürich, Bern und Berlin gehabt und freuen uns nun riesig auf eine (neue) Community in München.</p> <p>Unsere Agenda ist gefüllt mit 2 super Speakern und einem tollen Apero, (von LinkedIn Learning organisiert).</p> <p>18:00 - Einlass &amp; Registrierung</p> <p>18:30 - Keynote - tbd.</p> <p>18:45 - Stephan Bail - Talk tbd</p> <p>19:15 - Marco Hochstrasser - AI für Predictive Analytics</p> <p>19:45 - Snacks, Drinks, Networking</p> <p>21:00 - Veranstaltungsende</p> <p>Wenn ihr unsere Speaker bereits vorher "kennen lernen" wollt, dann schaut auf LinkedIn vorbei:<br/>Stephan Bail: <a href="https://www.linkedin.com/in/stephan-bail/" class="linkified">https://www.linkedin.com/in/stephan-bail/</a><br/>Marco Hochstrasser: <a href="https://www.linkedin.com/in/mhochstr/" class="linkified">https://www.linkedin.com/in/mhochstr/</a></p> <p>Und wir sind natürlich auch bereits auf LinkedIn vertreten. Hier gibts regelmässig News und Updates rund um den Einsatz von Künstliche Intelligenz im Business.<br/><a href="https://www.linkedin.com/company/ai-zurich/" class="linkified">https://www.linkedin.com/company/ai-zurich/</a></p> <p>Bis bald<br/>Eure Sophie Hundertmark</p> <p>P.S.: Verpasst nicht unsere Grosse AI FOR BUSINESS KONFERENZ am[masked] in Zürich.<br/><a href="https://ai-zurich.ch/" class="linkified">https://ai-zurich.ch/</a><br/>(Für alle Nicht-CH Gäste gibt es die Zürich Card für 3 Tage dazu geschenkt.)</p> ',
      how_to_find_us:
        "Zugang in der Hofstatt-Einkaufspassage (direkt neben Depot)",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1569835687000,
      duration: 10800000,
      id: "265279508",
      name: "Mobility and Location Intelligence ",
      rsvp_limit: 150,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575393300000,
      local_date: "2019-12-03",
      local_time: "18:15",
      updated: 1574328872000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 125,
      venue: {
        id: 26052175,
        name: "Wayra Germany GmbH",
        lat: 48.13779830932617,
        lon: 11.571670532226562,
        repinned: true,
        address_1: "Kaufingerstraße 15",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1551172295000,
        name: "Geomob Munich #geomobMUC",
        id: 31257448,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Geomob-Munich-geomobMUC",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Geomob-Munich-geomobMUC/events/265279508/",
      description:
        '<p>Welcome to the 4th Geomob of the year! This time we meet at Wayra for an evening filled with awesome talks and spatial conversations!</p> <p>The goal of #geomobMUC will be the same as #geomob London and Barcelona: to provide a forum to learn and exchange ideas about interesting services and projects that deal with location. Everyone working in or curious about the location space or with location services is welcome, you do not need to be some sort of GIS expert (though GIS experts are of course welcome as well). What I am most interested in is not pure geo technology, but rather the application of new geo technologies in services and product of all kind. The goal is not pitch presentations or marketing, but rather interesting talks by doers about their experiences.</p> <p>The talks are a chance to learn, but equally important is the dialogue between the attendees.</p> <p>Come by and join us!</p> <p>####################################################################<br/>AGENDA: Great talks, interesting discussions and drinks!<br/>####################################################################</p> <p>We will follow the time-tested #geomob format followed in London and Barcelona with a slight change</p> <p>Doors open at 18.30. All talks will be in English.</p> <p>(1) Live Maps for Auto and Mobility</p> <p>Alex Barth, Head of Auto at Mapbox will give a run down on how Mapbox can power your automotive or mobility application on iOS, Android or Linux.</p> <p>(2) Mobility data harvesting - Fruits and challenges</p> <p>Petr Suk, Data Scientist at CleverMaps will talk about the challenges and possibilities with mobility data analytics.</p> <p>(3) High definition 3D information for mobility applications</p> <p>Rolf Wojtech, Chief Software Architect at Blickfeld, a munich-based startup will talk about the current limitations of LiDAR, how they can be overcome, and which mobility applications can benefit from Light Detection and Ranging.</p> <p>(4) Laws governing Autonomous Driving</p> <p>Lüder Kaiser, Lawyer will talk about the current laws for cars, how the law was incorporated to make it work with Level 4 and what are the considerations that lack for Level 5 and how can the law be improved to incorporate the completely driver-less cars.</p> <p>(5) Smarter way to park for cleaner cities and happier drivers</p> <p>Searching for parking in the city can be annoying, costs the driver a lot of money and stress, and it\'s a burden on the environment. AlterMobili, a Munich-based smart mobility startup, takes a unique approach to reduce time wasted on cruising for parking. With the help of a smartphone app and a small, autonomous hardware chip, they can detect parking spots up to 60 seconds before they become available, and alert their nearby users searching for a free spot, giving them an advantage over other drivers.</p> <p>Interested in speaking at the event? Send us an email at [masked]</p> <p>Afterward, we will host a discussion and networking session. Looking forward to getting everyone connected with each other!</p> <p>####################################################################<br/>Spread the word and stay updated<br/>####################################################################</p> <p>Please tell everyone you know who may find the evening interesting. Subscribe on our website to stay updated about all events <a href="https://thegeomob.com/" class="linkified">https://thegeomob.com/</a></p> <p>Our low-volume mailing list serves as a way to remind you of upcoming #geomobs and share brief post-event summaries. <a href="https://thegeomob.com/mailing-list" class="linkified">https://thegeomob.com/mailing-list</a></p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1573738822000,
      duration: 5400000,
      id: "266462136",
      name: "Save the date: Weihnachtsglühweintreffen der Munich Legal Hackers",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576778400000,
      local_date: "2019-12-19",
      local_time: "19:00",
      updated: 1573738822000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 18,
      venue: {
        id: 26732784,
        name: "Wittelsbacherplatz",
        lat: 48.1432991027832,
        lon: 11.57608699798584,
        repinned: false,
        address_1: "Wittelsbacherpl.",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1473061527000,
        name: "Munich Legal Hackers",
        id: 20389421,
        join_mode: "approval",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "munich-legal-hackers",
        who: "Legal Hackers",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/munich-legal-hackers/events/266462136/",
      description:
        "<p>Wir treffen uns zum Jahresausklang und Glühwein. Vss. auf dem Mittelaltermarkt am Wittelsbacherplatz, München</p> <p>Details to follow.</p> <p>Stefan &amp; Paul für die Munich Legal Hackers</p> ",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571904644000,
      duration: 32400000,
      id: "265920923",
      name: "Devs meet Shopware 6",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575619200000,
      local_date: "2019-12-06",
      local_time: "09:00",
      updated: 1572423587000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 14,
      venue: {
        id: 26192467,
        name: "Design Offices München Nove",
        lat: 48.14472579956055,
        lon: 11.538229942321777,
        repinned: true,
        address_1: "Luise-Ullrich-Straße 14",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1571770711000,
        name: "Shopware Developers München",
        id: 32925628,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Shopware-Developers-Muenchen",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Shopware-Developers-Muenchen/events/265920923/",
      description:
        '<p>Du bist neugierig auf Shopware 6, weißt aber nicht, wo Du anfangen sollst? Du bist (noch) kein Teil des Shopware-Ökosystems? Dann solltest Du unser Developer Event “Meet Shopware 6” nicht verpassen. Wir zeigen Dir, was uns an Shopware begeistert, warum wir es lieben, mit Shopware zu arbeiten und warum auch Du es lieben wirst. Wenn Du mit Symfony, Bootstrap und Vue.js vertraut bist, wirst Du Dich wie zu Hause fühlen. Auch wenn nicht - die Entwicklung mit Shopware 6 fühlt sich extrem intuitiv an*. Während des Events werden wir es beweisen: Du wirst die Shopware-Entwickler treffen und wir werden gemeinsam erste Erweiterungen bauen.</p> <p>Beginne Deine Reise mit Shopware 6 noch heute - Registriere Dich hier: <a href="https://www.shopware.com/en/devs-meet-shopware-6-munich/" class="linkified">https://www.shopware.com/en/devs-meet-shopware-6-munich/</a></p> <p>Bitte beachte: Das Dev Event wird auf Englisch sein, die Shopware Entwickler sprechen natürlich auch Deutsch.</p> <p>Voraussetzungen:<br/>- Laptop<br/>- Running Shopware developer setup<br/>- Basic knowledge on Symfony &amp; Vue.js<br/>- Curiosity &amp; Team spirit</p> <p>Agenda:<br/>09:00 - 09:30 am: Opening and a small breakfast<br/>09:30 - 10:30 am: Welcome and Kickoff Shopware 6<br/>10:30 - 12:00 am: Onboarding Development Shopware 6<br/>12:00 - 12:45 am: Lunch<br/>12:45 - 04:45 pm: Development Session Shopware 6<br/>04:45 - 05:15 pm: Recap / Q&amp;A Session<br/>05:15 - 06:00 pm: Networking</p> <p>Jetzt kostenlos registrieren: <a href="https://www.shopware.com/en/devs-meet-shopware-6-munich/" class="linkified">https://www.shopware.com/en/devs-meet-shopware-6-munich/</a></p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1573221069000,
      duration: 10800000,
      fee: {
        accepts: "cash",
        amount: 8,
        currency: "EUR",
        description: "",
        label: "Price",
        required: false
      },
      id: "266315606",
      name: "3rd Happiness Research Meetup: Happiness vs. Burn-out",
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575478800000,
      local_date: "2019-12-04",
      local_time: "18:00",
      updated: 1573221172000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 34,
      venue: {
        id: 26021892,
        name: "Lebensversicherung von 1871 a. G. München (LV 1871)",
        lat: 48.14217758178711,
        lon: 11.570405006408691,
        repinned: true,
        address_1: "Maximilianspl. 5",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1539791926000,
        name: "Munich Happiness Research",
        id: 30338012,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Munich-Happiness-Research",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Munich-Happiness-Research/events/266315606/",
      description:
        '<p>Dear friends of profound happiness, it’s been way too long!</p> <p>Apologies for the loooong radio silence - we’ve been very busy and only now found the time and location to host our 3rd Munich Happiness Research Meetup:<br/>- on Wednesday, December 4th, 2019 at 6:00 pm<br/>- in the lobby of our kind Meetup host LV1871 (conveniently located at Maximiliansplatz 5, 80333 Munich)</p> <p>This time, we’ve decided to look at a slightly more serious topic, titled “Happiness vs. Burn-out”.</p> <p>We all want happiness in our lives – but pursuing it is hard, and costs time &amp; effort. Meanwhile, we are also facing accelerating challenges in our busy daily schedules – from the roles we assume, the job we want, the people we like, the society with live in, and the environment we destroy. So how do we manage to find happiness without “burning out” first? We’ll explore how these two are linked and share insights what we can do to stay sane on our purpose of happiness.</p> <p>Expect an exciting evening with inspirational keynotes, some science, an interactive mini-workshop, and of course great networking with happy people.</p> <p>Thus far we\'ve confirmed the following amazing speakers (detailed agenda will follow later):</p> <p>- Pia Baur (life coach, mindful business trainer – www.piabaur.de), who will share inspiring insights on the impact of empathy on stress and how this can support a motivated and fulfilling (work-) life<br/>- Regina Maueröder (psychologist, coach, change manager – <a href="https://regina-maueroeder.de" class="linkified">https://regina-maueroeder.de</a>), who will let us in on the intricacies on what stress &amp; burn-out actually mean, and how we can deal with them<br/>- me (Dr. Valentin Schellhaas, founder of zentor and former business monkey), who will share some scientifically inspired thoughts on happiness and guide through a mini-workshop</p> <p>Given we are still bootstrapping and are putting effort &amp; own funding into this, we\'ll be asking for the small contribution of €8,- which includes the inspirational talks, workshop, DRINKS &amp; SNACKS. Employees of our kind host LV1871 get in for free, of course.</p> <p>We look very much forward to seeing you there!</p> ',
      how_to_find_us: "Public transport: Karlsplatz/Stachus",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1571297779000,
      duration: 7200000,
      id: "265736471",
      name: "F10 Dezember19 Dojo",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576242000000,
      local_date: "2019-12-13",
      local_time: "14:00",
      updated: 1571297779000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      venue: {
        id: 26228783,
        name: "Friedenheimer Brücke 21",
        lat: 48.14567947387695,
        lon: 11.519824028015137,
        repinned: true,
        address_1: "Friedenheimer Brücke 21",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1551878701000,
        name: "F10 Coding Dojo",
        id: 31321481,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "F10-Coding-Dojo",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/F10-Coding-Dojo/events/265736471/",
      description:
        "<p>Wir beginnen um 14 Uhr mit dem Coding Dojo. Snacks sind vorhanden. Bring' deinen Laptop mit, wenn möglich.</p> <p>The coding dojo starts at 2 PM. Snacks are in stock. Bring your laptop.</p> ",
      visibility: "public",
      member_pay_fee: false
    },
    {
      local_time: "18:00",
      local_date: "2019-11-27",
      link:
        "https://www.meetup.com/Digital-Healthcare-Entrepreneurship/events/265206005/",
      visibility: "public_limited",
      group: {
        created: 1502963376000,
        name: "Digital Healthcare Entrepreneurship",
        id: 25512358,
        join_mode: "approval",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Digital-Healthcare-Entrepreneurship",
        who: "Healthcare Enthusiasts",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      waitlist_count: 0,
      yes_rsvp_count: 109,
      duration: 10800000,
      time: 1574874000000,
      utc_offset: 3600000,
      name: "Healthcare Innovation Night - Prelude to Digital Health Summit",
      id: "265206005"
    },
    {
      created: 1573157905000,
      duration: 7200000,
      id: "266296139",
      name:
        "Meeting 01: Security for Automotive Applications - Types of Attacks",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576085400000,
      local_date: "2019-12-11",
      local_time: "18:30",
      updated: 1573157905000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 43,
      venue: {
        id: 26722082,
        name: "INVENSITY GmbH",
        lat: 48.15583419799805,
        lon: 11.58479118347168,
        repinned: false,
        address_1: "Giselastraße 3A",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1572887129000,
        name: "Automotive Security Research Group-München (ASRG-MUC)",
        id: 32976551,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Automotive-Security-Research-Group-Munchen-ASRG-MUC",
        who: "Members",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Automotive-Security-Research-Group-Munchen-ASRG-MUC/events/266296139/",
      description:
        "<p>Hi everyone,</p> <p>we are exited to announce the first meeting of ASRG-MUC! Next to Stuttgart, Munich will be the second ASRG chapter in Germany and give an opportunity to network, collaborate and exchange knowledge with local Automotive Security professionals and enthusiasts.</p> <p>ASRG founder John Heldreth will give us some insights into his vision and plans for ASRG. We will then discuss about some current published Automotive Security news and provide an overview of interesting upcoming Security Events.</p> <p>The main presentation will be given by Marcus Lanke and Dr. Peter Laackmann from Infineon Technologies AG. They will talk about the evolution of attack methodologies against automotive components, including an outlook into the future. Different classes of attacks will be covered: protocol fuzzing, manipulative attacks, advanced side-channel information extraction as well as fault-injection scenarios. Their presentation will include several illustrative hardware demonstrations and is directed towards both experts and newcomers in the field of Automotive Security.</p> <p>I look forward to seeing many of you there!</p> <p>AGENDA<br/>=========<br/>- Introduction to ASRG<br/>- Automotive Security in the News<br/>- Events / Competitions<br/>- Main-presentation: Security for Automotive Applications - A Comprehensive Introduction to Attacks</p> ",
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1574157126000,
      duration: 34200000,
      id: "266578032",
      name: "Innovators Connect Vol. 2 & MLB Demo Day",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575637200000,
      local_date: "2019-12-06",
      local_time: "14:00",
      updated: 1574166462000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 6,
      venue: {
        id: 26170711,
        name: "Media Lab Bayern",
        lat: 48.122798919677734,
        lon: 11.605680465698242,
        repinned: true,
        address_1: "Rosenheimer Str. 145C",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1542707415000,
        name: "Mediatrends & Innovation",
        id: 30562336,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "mediatrends_and_innovation",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/mediatrends_and_innovation/events/266578032/",
      description:
        '<p>Innovators Connect - Boost your 2020 Innovation Strategy!</p> <p>2020 is das Jahr in dem wir Innovationsprojekte zur Realität werden lassen. Mit welchen Strategien und welchen Tools? Wir zeigen es euch bei unserem Hands-On Demo Day!</p> <p>An welchen Trends kommt euer Unternehmen 2020 nicht vorbei? Mit welchen Strategien und Methoden werden Innovationsprojekte in Innovation Labs anderer Branchen erfolgreich umgesetzt? Und wie klappt die Kooperation mit Startups langfristig?</p> <p>In interaktiven Fish-Bowl Diskussionen mit Experten und hands-on Workshops mit unseren Startups könnt ihr eure Strategie für erfolgreiche Innovationsprojekte 2020 optimieren!</p> <p>Bei Innovators Connect erwarten euch ...</p> <p>- Visionäre Speaker mit Trend-Outlook (u.a. 5G, Future of Digital Advertising, AI und Datenjournalismus)<br/>- Innovation Labs außerhalb der Medienindustrie<br/>- Startup Kooperationen eintüten: Workshops mit unseren Startups aus Batch#6<br/>- Startup Mindset &amp; Learnings: Final Pitches vom Batch#5 - mit allen Learnings der letzten 9 Monate<br/>- Durchstarter Tipps 2020: Release des Media Lab Innovation Guidebooks<br/>- ganz viele Plätzchen, Punsch &amp; Santa Vibes</p> <p>- AGENDA SNEAK PEAK -</p> <p>13:30 | Doors open<br/>14:00 | Welcome &amp; Innovation - 2020! So starten wir nächstes Jahr durch<br/>14:15 | Keynote - Rethink Digital Advertising<br/>14:45 | Fishbowl-Discussion: Innovation Labs außerhalb der Medien<br/>15:30 | Shortpitches by Media Startup Fellowship Batch #6<br/>15:40 | Coffee Break<br/>16:00 | Workshops by Media Startup Fellowship Batch#6<br/>&gt; Community-Building mit 1E9<br/>&gt; KPIs for digital PR mit aclipp<br/>&gt; EdTech meets Media mit flowra<br/>&gt; Data-driven Publishing mit Focal Analytics<br/>&gt; FitTech in Media mit Jalu<br/>&gt; Reader Engagement mit RosaMag<br/>&gt; Globalising Journalism mit The Story Market<br/>&gt; Re-inventing the Mobile Ad Market mit Veeplay<br/>16:40 | Learnings by Media Startup Fellowship Batch#5<br/>&gt; flint.gg: Den Gaming Markt verstehen lernen<br/>&gt; Kerngedanke: Social Kanäle richtig bespielen<br/>&gt; Luminovo: Dokumente und Texte automatisiert bearbeiten<br/>&gt; Sidepreneur: Wie man innovative Mitarbeiter fördert<br/>&gt; Varia: neue Perspektiven mit KI-Filtern<br/>&gt; Webmag: Corporate Publishing neu erfinden<br/>17:15 | Closing Keynote: Leap into 2020 - An diesen Trends kommt ihr nicht vorbei<br/>AB 18:30 Media Lab Innovation Guide Release Party<br/>&amp; Startup-Xmas Party</p> <p>...mehr Info kommt bald</p> <p>Registriere dich gerne schon vorab für das Event:<br/><a href="https://www.media-lab.de/innovators-connect#Anmelden" class="linkified">https://www.media-lab.de/innovators-connect#Anmelden</a></p> ',
      visibility: "public",
      member_pay_fee: false
    },
    {
      created: 1573571377000,
      duration: 12600000,
      id: "266408968",
      name: "Real World DevOps with Abel Wang",
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575478800000,
      local_date: "2019-12-04",
      local_time: "18:00",
      updated: 1573672453000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 48,
      venue: {
        id: 26051517,
        name: "Microsoft Germany GmbH",
        lat: 48.1776237487793,
        lon: 11.593453407287598,
        repinned: true,
        address_1: "Walter-Gropius-Straße 5",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1562061882000,
        name: "Azure DEV Meetup Munich",
        id: 32304402,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Azure-DEV-Munich",
        who: "Azure native",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Azure-DEV-Munich/events/266408968/",
      description:
        "<p>Join us in welcoming Abel Wang (Microsoft, Redmond) for a packed evening about Real World DevOps</p> <p>Agenda:<br/>• 18:00 - 18:30 Open Doors<br/>• 18:30 - 20:00 \"Real World DevOps\" - Abel Wang<br/>• 20:00 - 21:00 \"Azure DevOps How to Build an extension\" - Christian Waha<br/>• 21:00 - 21:30 Open Discussion, Networking</p> <p>**Real World DevOps**<br/>It is now 2019 and good DevOps practices are no longer just nice to have. It is absolutely necessary to continuously deliver value to our end users. Yet this isn't easy to do right. Unfortunately, all the flashy Hello World DevOps demos we see at conferences don’t really help us figure out how to do DevOps in the real world. They don’t even let us know what is possible.<br/>In this session, we change all of that. We explore the why's and the how. Why is DevOps important? Why do we care? How do we implement DevOps best practices? And finally, we will do a real world deep dive.</p> <p>Starting from nothing at all except source code (and I mean NOTHING. No infrastructure at all) we end with a complex modern application deployed all the way out into production hosted in the cloud.</p> <p>We touch on modern technologies and techniques. From Infrastructure as Code to setting up DNS. From web front ends, to deploying databases. From API's hosted in Kubernetes clusters all he way to mobile apps. And we do everything from within our pipelines. With the right tooling, anything is possible. And in this session, you will see all this happen live with DevOps best practices including IaC, Database DevOps, Security and Quality!</p> <p>*Speaker*</p> <p>Abel Wang (Microsoft)</p> <p>Abel Wang is a Principal Cloud Advocate and DevOps Lead with a background in application development at Micorsoft. He is currently part of Donovan Brown's League of Extraordinary Cloud DevOps Advocates.</p> <p>Before joining Microsoft, Abel spent seven years as a Process Consultant and a Certified Scrum Master helping customers globally develop solutions using agile practices and Team Foundation Server.</p> <p>Prior to that, Abel founded and sold his own software company. When not working, Abel is either writing code (yes, that’s what he does for fun), playing his guitar or training for The Great Wall Marathon.</p> <p>Recently winning his fight against cancer, Abel spits in the face of cancer and will never quit.</p> <p>-----------------------</p> <p>**Azure DevOps: How to Build an extension**</p> <p>This session shows you how you can extend Azure DevOps (also Azure DevOps Server former Team Foundation Server). You see how to create an extension, what are the key points to manage and how to publish it to the Marketplace.</p> <p>*Speaker*</p> <p>Christian Waha – Technical Fellow @ti&amp;m AG, MVP, Windows Insider MVP</p> <p>Christian ist als Technical Fellow heute Markenbotschafter und Technischer Ansprechpartner für Microsoft Cloud Services speziell Azure ist sein Schwerpunkt. Er seit 25 Jahren im IT Umfeld als Experte unterwegs. Wichtige Stationen in dieser Zeit sind die UniCredit Bank / UGIS, die 1&amp;1, die Bauch &amp; Lomp, die T-Systems. In den letzen Jahren hat er sich stark auf seine neue Heimat, die Schweiz konzentriert und dort die Cloud Strategie der Helsana gefördert. Christian ist zu dem seit mehreren Jahren MVP (Microsoft Most Valuable Professional) und seit einigen Jahren zusätzlich Windows Insider MVP, zusätzlich ist er auch als Scrum Master, Product Owner und LEGO Serious Play Fascilitator zertifiziert.</p> ",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1570549809000,
      duration: 27000000,
      id: "265505050",
      name: "Global AI Bootcamp - Eventbrite registration requiered",
      rsvp_limit: 100,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1576312200000,
      local_date: "2019-12-14",
      local_time: "09:30",
      updated: 1570549809000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 41,
      venue: {
        id: 26051517,
        name: "Microsoft Germany GmbH",
        lat: 48.1776237487793,
        lon: 11.593453407287598,
        repinned: true,
        address_1: "Walter-Gropius-Straße 5",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1562061882000,
        name: "Azure DEV Meetup Munich",
        id: 32304402,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Azure-DEV-Munich",
        who: "Azure native",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link: "https://www.meetup.com/Azure-DEV-Munich/events/265505050/",
      description:
        '<p>The Global AI Bootcamp is a free one-day event organized across the world by local communities that are passionate about artificial intelligence on Microsoft Azure.<br/>Please take a moment and register here: <a href="https://global-ai-bootcamp.eventbrite.de" class="linkified">https://global-ai-bootcamp.eventbrite.de</a></p> <p>More will come up soon</p> <p>Call for Speaker : <a href="https://sessionize.com/global-ai-bootcampmuc/" class="linkified">https://sessionize.com/global-ai-bootcampmuc/</a></p> ',
      how_to_find_us:
        "Microsoft Germany\nWalter-Gropius-Straße 5\n80807 Munich\nGermany",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    },
    {
      created: 1572679119000,
      duration: 10800000,
      id: "266156582",
      name: "360 degree view on urban mobility platforms",
      rsvp_limit: 120,
      date_in_series_pattern: false,
      status: "upcoming",
      time: 1575480600000,
      local_date: "2019-12-04",
      local_time: "18:30",
      updated: 1574263344000,
      utc_offset: 3600000,
      waitlist_count: 0,
      yes_rsvp_count: 63,
      venue: {
        id: 26170563,
        name: "IBM Watson IoT Tower",
        lat: 48.176536560058594,
        lon: 11.592637062072754,
        repinned: true,
        address_1: "Mies-van-der-Rohe-Straße 6",
        city: "München",
        country: "de",
        localized_country_name: "Germany"
      },
      group: {
        created: 1572348604000,
        name: "Future of Mobility @ Munich",
        id: 32949222,
        join_mode: "open",
        lat: 48.13999938964844,
        lon: 11.579999923706055,
        urlname: "Future-of-Mobility-Munich",
        who: "Mitglieder",
        localized_location: "München, Germany",
        state: "",
        country: "de",
        region: "en_US",
        timezone: "Europe/Berlin"
      },
      link:
        "https://www.meetup.com/Future-of-Mobility-Munich/events/266156582/",
      description:
        "<p>Traffic in German cities is increasing, and so are the challenges.<br/>To ensure that urban mobility remains efficient and safe in the<br/>future, alternative mobility concepts can be offered through<br/>new technological developments and urban mobility can be made<br/>city-compatible. Almost all new usage models are available on<br/>innovative platforms. In our MeetUp we would like to have a 360-<br/>degree view on urban mobility platforms with 3 experts from 3<br/>different perspectives - the business, operations and technology<br/>perspective.<br/>Afterwards there will be a discussion with our visitors and the<br/>opportunity for networking.</p> <p>AGENDA<br/>6:30 pm Doors open</p> <p>7:00 pm Welcome note from hosts</p> <p>7:15 pm Business View on urban mobility platforms<br/>(Dr. Mario Lochmüller, CEO &amp; Founder of Moovster)</p> <p>7:40 pm Operational View on urban mobility platforms<br/>(Philipp Risse, Regional Operations Manager South Germany, TIER Mobility)</p> <p>8:05 pm Technology View on urban mobility platforms<br/>(Steffen Krause, IT Architect &amp; Smarter Mobility Lab<br/>Leader IBM)</p> <p>8:30 pm Panel Discussion with all keynote speakers and open<br/>questions from audience</p> <p>9:00 pm Beer, Pizza &amp; Networking</p> <p>****************Please note this Meetup is hold in German******************</p> ",
      how_to_find_us:
        "Please take one of the elevators in the Lobby of the IBM Tower and ask one of our meetup supporters to bring you to the location.",
      visibility: "public",
      pro_is_email_shared: false,
      member_pay_fee: false
    }
  ]
};

export { mockEvents };
